module.exports = __webpack_public_path__ + "static/img/call-pass.4a471879.png";